import React from 'react';
import ProgressBarsContainer from '../../Componant/UiKits/Progress';

const ProgressBars = () => {
  return (
    <div className='page-body'>
      <ProgressBarsContainer />
    </div>
  );
};

export default ProgressBars;
